import { ChatContext } from './types';

export type ProactiveMessage = {
  message: string;
  prefilledQuestion: string;
  severity: 'critical' | 'warning';
};

export function getProactiveMessage(context: ChatContext): ProactiveMessage | null {
  if (context.surface !== 'funnel' || !context.funnel) return null;

  const f = context.funnel;
  const profitGap = f.unitTargets.expectedProfitPct - f.unitEconomics.finalProfitPct;
  const cpaOverMax = f.unitEconomics.cpa - f.unitTargets.targetCpaMaxProfitable;
  const returnsGap = f.unitEconomics.returnsRate - f.unitTargets.returnsRate;

  if (cpaOverMax > 0) {
    return {
      severity: 'critical',
      message: 'Tu CPA está arriba del máximo rentable. Estás perdiendo plata en cada venta. ¿Te ayudo a bajarlo?',
      prefilledQuestion: '¿Cómo puedo bajar mi CPA? Está arriba del máximo rentable.',
    };
  }

  if (profitGap > 10) {
    return {
      severity: 'critical',
      message: `Tu utilidad está ${profitGap.toFixed(1)} puntos por debajo del objetivo. ¿Te ayudo a encontrar dónde se está yendo la plata?`,
      prefilledQuestion: '¿Por qué mi utilidad por orden está tan baja?',
    };
  }

  if (returnsGap > 3) {
    return {
      severity: 'warning',
      message: `Tus devoluciones están ${returnsGap.toFixed(1)} puntos arriba del objetivo. Cada una presiona flete, margen y caja. ¿Lo revisamos?`,
      prefilledQuestion: '¿Por qué son tan altas mis devoluciones?',
    };
  }

  if (profitGap > 5) {
    return {
      severity: 'warning',
      message: `Tu utilidad está ${profitGap.toFixed(1)} puntos por debajo del objetivo. ¿Quieres que revisemos juntos?`,
      prefilledQuestion: '¿Cómo mejoro mi utilidad?',
    };
  }

  return null;
}
